import { Navigate } from 'react-router-dom';
import type { RouteObject } from 'react-router-dom';
import ErrorBoundary from './ErrorBoundary';

// project imports
import MinimalLayout from 'layout/MinimalLayout';

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes: RouteObject = {
  path: '/',
  element: <MinimalLayout />,
  errorElement: <ErrorBoundary />,
  children: [
    {
      // NEX-1335 — página del diseño anterior, sin ningún link real que lleve
      // ahí. Se redirige en vez de mostrarla; el componente queda sin borrar.
      path: '/pages/coming-soon1',
      element: <Navigate to="/" replace />
    },
    {
      path: '*',
      element: <Navigate to="/" replace />
    }
  ]
};

export default AuthenticationRoutes;
